import React, { useState, useEffect } from "react";
import { useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import ViewSelector from "../common/ViewSelector";
import SwipeableViews from "react-swipeable-views";
import { useStyles } from "./styles"

const UsageView = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeView, setActiveView] = useState(0);
  const viewNames = ["Usage", "Generation", "867 Usage", "Net Metering Bank"];

  const _setActiveView = async (value) => {
    setActiveView(value);
  };

  useEffect(() => {
    _setActiveView(activeView);
  }, [activeView]);

  return (
    <div className={classes.viewContainer}>
      <ViewSelector
        viewNames={viewNames}
        activeView={activeView}
        setActiveView={setActiveView}
      >
        {viewNames.map((option, index) => {
          return (
            <Tab
              key={index}
              className={activeView === index ? `view activeView` : `view`}
              label={option}
            ></Tab>
          );
        })}
      </ViewSelector>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeView}
      >
        {props.children}
      </SwipeableViews>
    </div>
  );
};

UsageView.propTypes = {};

export default UsageView;
